

































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class LanguageTextInput extends Vue {
  @Prop()
  private obj!: any;

  @Prop()
  private prependIcon!: string;

  @Prop()
  private placeholder!: string;

  @Prop()
  private disabled!: boolean;

  @Prop()
  private filled!: boolean;

  @Prop()
  private property!: string;

  @Prop()
  private solo?: string;

  @Prop()
  private name!: string;

  @Prop()
  private label!: string;

  private language = this.$store.state.user.languageId || 1;

  @Watch('$store.state.user.languageId')
  private onLanguageChange() {
    this.language = this.$store.state.user.languageId || 1;
  }

  get value() {
    if (!this.obj[this.property]) return '';
    const langaugeSpecificValue = this.obj[this.property].find(
      (item: any) => item.languageId === this.language
    );
    if (!langaugeSpecificValue) return '';
    return langaugeSpecificValue[this.name] || '';
  }

  set value(value: string) {
    if (!this.obj[this.property]) {
      const object: any = {
        languageId: this.language
      };
      object[this.name] = value;
      this.obj[this.property] = [object];
    } else {
      const item = this.obj[this.property].find((i: any) => i.languageId === this.language);
      if (!item) {
        const object: any = {
          languageId: this.language
        };
        object[this.name] = value;
        this.obj[this.property].push(object);
      } else {
        item[this.name] = value;
      }
    }
  }
}
